// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_headerLayout__1T2RA {
  background: var(--color-nav-bg);
  box-shadow: var(--shadow-md);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.styles_headerLayout__1T2RA.styles_headerLayoutDiseable__rv4Ga {
  display: none;
}
.styles_headerLayout-content__6WMmE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  height: 72px;
}
.styles_headerLayout-content__6WMmE .styles_info__8Vps7 {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.styles_headerLayout-content__6WMmE .styles_greeting__D6EWi {
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.styles_headerLayout-content__6WMmE .styles_name__To3lF {
  font-size: 17px;
  font-weight: 700;
  color: #FFFFFF;
  line-height: 1.2;
  letter-spacing: -0.01em;
}
.styles_headerLayout-content__6WMmE .styles_user__bSict {
  width: 44px;
  height: 44px;
  overflow: hidden;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}
.styles_headerLayout-content__6WMmE .styles_user-img__aAVku {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/templates/partials/Header/styles.module.scss"],"names":[],"mappings":"AAAA;EAKI,+BAAA;EACA,4BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAHJ;AAPI;EACI,aAAA;AASR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AAAR;AAEQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAAZ;AAGQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,sBAAA;AADZ;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAFZ;AAKQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,oCAAA;EACA,cAAA;AAHZ;AAKY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAHhB","sourcesContent":[".headerLayout {\n    &.headerLayoutDiseable {\n        display: none;\n    }\n\n    background: var(--color-nav-bg);\n    box-shadow: var(--shadow-md);\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 100;\n\n    &-content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 1rem 1.25rem;\n        height: 72px;\n\n        .info {\n            display: flex;\n            flex-direction: column;\n            gap: 1px;\n        }\n\n        .greeting {\n            font-size: 11px;\n            font-weight: 400;\n            color: rgba(255,255,255,0.6);\n            text-transform: uppercase;\n            letter-spacing: 0.06em;\n        }\n\n        .name {\n            font-size: 17px;\n            font-weight: 700;\n            color: #FFFFFF;\n            line-height: 1.2;\n            letter-spacing: -0.01em;\n        }\n\n        .user {\n            width: 44px;\n            height: 44px;\n            overflow: hidden;\n            border-radius: 50%;\n            border: 2px solid rgba(255,255,255,0.25);\n            background: rgba(255,255,255,0.1);\n            flex-shrink: 0;\n\n            &-img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerLayout": `styles_headerLayout__1T2RA`,
	"headerLayoutDiseable": `styles_headerLayoutDiseable__rv4Ga`,
	"headerLayout-content": `styles_headerLayout-content__6WMmE`,
	"info": `styles_info__8Vps7`,
	"greeting": `styles_greeting__D6EWi`,
	"name": `styles_name__To3lF`,
	"user": `styles_user__bSict`,
	"user-img": `styles_user-img__aAVku`
};
export default ___CSS_LOADER_EXPORT___;
